import Reflux from "reflux";
import Actions from "../../../../../Actions";
import logger from "../../../../../utils/LoggerFrontend";
import { optimizeCloudinaryImage } from "../../../../../utils/Helpers";
import JobPageActions from "./JobPageActions";
import { getMediaAssets } from "../../componentUtils";

const defaultState = {
  teaserText: "",
  image: "",
  benefits: "",
  tasks: "",
  requirements: "",
  companyLogo: "",
  isFetchingJobPage: true,
  tbCampaignId: "",
  mediaAssetId: ""
};

const getMediaAssetData = async (mediaAssetId) => {
  logger.log("JobPageStore:getMediaAssetData", "fetching media asset data", {
    mediaAssetId
  });

  const mediaAssetData = await getMediaAssets([mediaAssetId]);
  if (mediaAssetData && mediaAssetData.length > 0) {
    return mediaAssetData[0].inputProps;
  }

  return "";
};

export default class JobPageStore extends Reflux.Store {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, defaultState);
    this.listenables = Object.assign(JobPageActions, Actions);
  }

  onUpdateJobPage(_campaignId, jobPageData) {
    this.setState(jobPageData);
  }

  onUpdateJobPageFailed(error) {
    logger.log("error:JobPageStore:onUpdateJobPageFailed", "unable to update job page data", {
      error
    });
  }

  onGetJobPage(tbCampaignId) {
    this.setState({ isFetchingJobPage: true, tbCampaignId });
  }

  onGetJobPageCompleted(jobPageData) {
    this.setState({ isFetchingJobPage: false, ...jobPageData });
  }

  onGetJobPageFailed(error) {
    logger.log("error:JobPageStore:onGetJobPageFailed", "unable to fetch job page data", {
      error
    });
    this.setState({ isFetchingJobPage: false });
  }

  // TODO: Move to a backend controller
  // Listen for changes on the "creatives" field of the ad previews
  // in order to update the job page image
  async onUpdatePost({ updateData = {} }) {
    let newImage = updateData?.creatives?.[0];
    const creativesIsNotUpdated = !newImage;
    const jobPageIsNotFetched = !this.state.tbCampaignId;
    const jobPageHasPicture = this.state.image;
    const isInvalidImage = !newImage?.includes("https");

    if (jobPageHasPicture || creativesIsNotUpdated || jobPageIsNotFetched || isInvalidImage) {
      return;
    }

    if (this.state.mediaAssetId) {
      const inputProps = await getMediaAssetData(this.state.mediaAssetId);

      if (inputProps?.backgroundImage === "") {
        logger.log("JobPageStore:onUpdatePost", "media asset updated", {
          mediaAssetId: this.state.mediaAssetId,
          backgroundImage: newImage,
          inputProps
        });
      }
    }

    newImage = optimizeCloudinaryImage(updateData?.creatives?.[0], "fit");

    this.setState({ image: newImage });

    JobPageActions.updateJobPage(this.state.tbCampaignId, {
      image: newImage,
      teaserText: this.state.teaserText,
      benefits: this.state.benefits,
      tasks: this.state.tasks,
      requirements: this.state.requirements,
      companyLogo: this.state.companyLogo
    });
  }

  onResetJobPage() {
    const newState = Object.assign({}, defaultState);
    this.setState(newState);
  }

  onResetPreviewData() {
    const newState = Object.assign({}, defaultState);
    this.setState(newState);
  }
}
